import { useMutation, useQueryClient } from 'react-query'

import { useCurrentSite } from '../../components/SitesProvider'
import request from '../../config/axios'
import QueryKeys from './QueryKeys'

export interface CreateNoteData {
  notableId: string
  notableType: string
  content: string
  siteId: string // Provided by the caller but overridden by the trusted site id.
}

interface CreateNoteResponse {
  note: {
    id: string
    // add additional fields if needed
  }
}

const useCreateNote = () => {
  const queryClient = useQueryClient()
  const trustedSiteId = useCurrentSite()?.id
  const url = '/impacts/notes'

  return useMutation(
    (data: CreateNoteData) => {
      const notePayload = {
        notable_id: data.notableId,
        notable_type: data.notableType,
        content: data.content,
        site_id: trustedSiteId, // override any client-provided value
      }
      return request.post<CreateNoteResponse>(url, {
        siteIds: [trustedSiteId],
        note: notePayload,
      })
    },
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries(
          QueryKeys.notes({
            notableId: variables.notableId,
            notableType: variables.notableType,
          }),
        )
      },
    },
  )
}

export default useCreateNote
